import { render, staticRenderFns } from "./TruckScannerPage.vue?vue&type=template&id=43303446&"
import script from "./TruckScannerPage.vue?vue&type=script&lang=js&"
export * from "./TruckScannerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports